if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        if (cartNotification) cartNotification.setActiveElement(this.openedBy);

        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;

        super.hide(preventFocus);
      }

      show(opener) {
  const spinner = opener.querySelector('.loading__spinner');

  opener.setAttribute('aria-disabled', true);
  opener.classList.add('loading');
  if (spinner) spinner.classList.remove('hidden');

  fetch(opener.getAttribute('data-product-url'))
    .then((response) => response.text())
    .then((responseText) => {
      const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');

      // Gate check — render gate message inside modal instead of redirecting
      const isPrivate = responseHTML.querySelector('.private-gate .page-width');
      if (isPrivate) {
        const gateContent = responseHTML.querySelector('.private-gate');
        this.modalContent.innerHTML = `
          <div style="padding: 40px 24px; text-align: center;">
            <p style="letter-spacing: 0.1em; text-transform: uppercase; font-size: 0.75em; opacity: 0.6; margin-bottom: 12px;">Collector Access Only</p>
            <h2 style="font-size: 1.2em; margin-bottom: 12px;">This product is reserved for NBB reward members.</h2>
            <p style="font-size: 0.9em; opacity: 0.7; margin-bottom: 24px;">
              ${document.querySelector('body').classList.contains('customer-logged-in')
                ? 'Your account doesn\'t have access to this drop.'
                : 'Sign in to see if you have access.'}
            </p>
            ${document.querySelector('body').classList.contains('customer-logged-in')
              ? ''
              : `<a href="/account/login?return_url=${encodeURIComponent(opener.getAttribute('data-product-url'))}" 
                   style="display:inline-block; padding: 12px 28px; background:#000; color:#fff; text-decoration:none; font-size:0.8em; letter-spacing:0.1em; text-transform:uppercase;">
                   Sign In
                 </a>`
            }
          </div>
        `;
        super.show(opener);
        return;
      }

      const productElement = responseHTML.querySelector('product-info');

      this.preprocessHTML(productElement);
      HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }

      if (window.ProductModel) {
        window.ProductModel.loadShopifyXR();
      }

      super.show(opener);
    })
    .finally(() => {
      opener.removeAttribute('aria-disabled');
      opener.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
    });
}



      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient') {
            this.modalContent.classList.add(classApplied);
          }
        });

        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;

        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);

        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => {
          li.setAttribute('role', 'presentation');
        });
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}